module.exports = __webpack_public_path__ + "img/big-screen.c01541d1.svg";